module.exports = __webpack_public_path__ + "img/MapThumb_RiverNile.63b82e3a.webp";